const STRIPE_TEST_KEY = "pk_test_NWV4IxfTTJUfb8ed1aPvUZNm";
const STRIPE_PROD_KEY = "pk_live_YZjIz5GCjTtmjQUxVsCC13Dt";

export const NUMVERIFY_API_KEY = "c70aa5b623a2407466f1075d9fe54a52";
export const DEFAULT_PAYMENT_PROVIDER = "BRAINTREE";

export const getStripeApiKey = () => {
    let key = STRIPE_TEST_KEY;
    if (process.env.NODE_ENV === 'production') {
        key = STRIPE_PROD_KEY
    }
    return key;
};